import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useTranslate } from "@similarweb/i18n-provider";

import { showSuccessToast } from "app/actions/toast_actions";
import { swSettings } from "app/common/services/swSettings";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import solutionUrlsService from "app/pages/sales-intelligence/services/solution-urls";
import { fetchContactsAdminsThunk } from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/effects";
import {
    selectContactsAdmins,
    selectIsContactsDisabledByCountry,
} from "app/pages/sales-intelligence/sub-modules/contacts-tab/store/selectors";
import { allTrackers } from "app/services/track/track";

const useContactsAdmins = () => {
    const dispatch = useDispatch();
    const { translate } = useTranslate();

    const isContactsDisabledByCountry = useSelector(selectIsContactsDisabledByCountry);
    const contactsAdmins = useSelector(selectContactsAdmins);
    const isUserManagementAllowed = salesSettingsHelper.isAdmin() || salesSettingsHelper.isInternalUser();
    const country = swSettings.user.userCountry;

    useEffect(() => {
        if (isContactsDisabledByCountry && !isUserManagementAllowed && contactsAdmins.length === 0) {
            dispatch(fetchContactsAdminsThunk());
        }
    }, [isContactsDisabledByCountry, isUserManagementAllowed, contactsAdmins.length]);

    const trackCountryRestrictions = (action: string, event: string) => {
        allTrackers.dispatchTrackEvent("contact country limit", action, event);
    };

    const onCopyEmail = () => {
        trackCountryRestrictions("copy email", `contact admin/${country}`);
        navigator.clipboard.writeText(contactsAdmins.join(", "));
        dispatch(
            showSuccessToast(
                translate(
                    contactsAdmins.length === 1
                        ? "si.account-overview.contacts.restricted.region.copy.success"
                        : "si.account-overview.contacts.restricted.region.copy.success.multiple",
                ),
            ),
        );
    };

    const onViewUserManagement = () => {
        trackCountryRestrictions("view user management", `user management/${country}`);
    };

    return {
        contactsAdmins,
        isUserManagementAllowed,
        accountUrl: solutionUrlsService.getAccountManagementUrl(),
        onCopyEmail,
        onViewUserManagement,
    };
};

export default useContactsAdmins;
